import { useEffect, useState } from "react";
import { format } from "date-fns";
import { useNavigate } from "react-router";

import { Badge } from "components/Badge";
import { Button } from "components/Button";
import { PageWithNav } from "components/PageWithNav";
import { Spinner } from "components/Spinner";
import { Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "components/Table";
import api from "utils/api";

export const Products = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const loadProducts = async () => {
    try {
      setIsLoading(true);
      const response = await api.get("/products");
      setProducts(response.data.products);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadProducts();
  }, []);

  return (
    <PageWithNav>
      <h1 className="mb-3 pe-4 text-xl font-semibold text-neutral-900">Products</h1>

      <p className="mb-4 text-sm text-neutral-400">
        Products are created in{" "}
        <a className="font-semibold text-blue-500 hover:text-blue-400 focus:text-blue-400" rel="noreferrer" href="https://dashboard.stripe.com/test/products?active=true" target="_blank">
          Stripe
        </a>
      </p>

      {isLoading && (
        <div className="flex justify-center">
          <Spinner size="lg" color="primary" />
        </div>
      )}

      {!isLoading && (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHeaderCell className="w-[0%]">ID</TableHeaderCell>
              <TableHeaderCell>Stripe Product ID</TableHeaderCell>
              <TableHeaderCell>Name</TableHeaderCell>
              <TableHeaderCell>Price</TableHeaderCell>
              <TableHeaderCell>Created</TableHeaderCell>
              <TableHeaderCell />
              <TableHeaderCell />
            </TableRow>
          </TableHeader>
          <TableBody emptyColSpan={7}>
            {products.length &&
              products.map((product) => {
                const parsedPriceInfo = JSON.parse(product.price_info);
                const unitAmount = parsedPriceInfo?.unit_amount;
                const currency = parsedPriceInfo?.currency;
                // Format price value
                const priceValue = (unitAmount / 100).toFixed(2) + " " + currency?.toUpperCase();

                return (
                  <TableRow key={product.id.toString()}>
                    <TableCell className="font-semibold">{product.id}</TableCell>
                    <TableCell>{product.product_id}</TableCell>
                    <TableCell>{product.name}</TableCell>
                    <TableCell>{priceValue}</TableCell>
                    <TableCell>{format(product.created_at, "do MMM yyyy")}</TableCell>
                    <TableCell>
                      <Badge type={product.is_active ? "success" : "danger"}>{product.is_active ? "Active" : "Inactive"}</Badge>
                    </TableCell>
                    <TableCell className="w-0">
                      <Button size="sm" onClick={() => navigate(`/products/manage/${product.id}`)}>
                        Manage
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      )}
    </PageWithNav>
  );
};
